<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="add-item-form"
	*ngIf="itemFormGroup"
	[ngClass]="{ 'add-form-outline': !item, 'edit-form-outline': item }"
>
	<form [formGroup]="itemFormGroup" class="member-form-container">
		<mat-form-field *ngIf="isAdd">
			<mat-label>{{ strings.PROJECT_MEMBER_EMAIL_PLACEHOLDER }}</mat-label>
			<input matInput name="email" formControlName="email" automationId="email" />
			<mat-error
				*ngIf="itemFormGroup.get('email')?.errors?.required || itemFormGroup.get('email')?.errors?.email"
			>
				{{ appStrings.PROJECT_MEMBER_EMAIL_INVALID }}
			</mat-error>
			<mat-error *ngIf="itemFormGroup.get('email')?.errors?.itemInList">
				{{ appStrings.PROJECT_MEMBER_EMAIL_EXISTS_ERROR }}
			</mat-error>
		</mat-form-field>

		<mat-form-field>
			<mat-label>{{ strings.PROJECT_MEMBER_PRIMARY_ROLE_PLACEHOLDER }}</mat-label>
			<mat-select name="roleId" formControlName="roleId" automationId="defaultRole">
				<mat-option *ngFor="let role of sortedRoles$ | async" [value]="role.$id">
					<div class="select-icon-option" automationId="defaultRoleOptions">
						<mat-icon class="role-color-select" [ngStyle]="{ background: role.view.color }"> </mat-icon>
						<span>{{ role.view.roleName }}</span>
					</div>
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field *ngIf="needMultiSelect(itemFormGroup)">
			<mat-label>{{ strings.PROJECT_MEMBER_ASSIGNED_ROLES_PLACEHOLDER }}</mat-label>
			<mat-select name="roles" multiple formControlName="roles" automationId="secondaryRole">
				<mat-option *ngFor="let role of sortedRoles$ | async" [value]="role.$id">
					<div class="select-icon-option" automationId="secondaryRoleOptions">
						<mat-icon class="role-color-select" [ngStyle]="{ background: role.view.color }"> </mat-icon>
						<span>{{ role.view.roleName }}</span>
					</div>
				</mat-option>
			</mat-select>
		</mat-form-field>

		<div>
			<mat-checkbox formControlName="admin" automationId="admin">
				{{ item && isOwner ? strings.PROJECT_MEMBERS_ADMIN_OWNER : strings.PROJECT_MEMBERS_ADMIN }}
			</mat-checkbox>

			<auto-hide-label
				#autoHideLabel
				*ngIf="isInvitedUser"
				[text]="strings.PROJECT_MEMBER_INVITED_SECTION_INVITATION_SENT"
				class="auto-hide-label"
			>
			</auto-hide-label>
		</div>
	</form>

	<button-footer
		(buttonSaveOrClose)="handleItemEvent({ type: 'Save', event: $event })"
		[disabled]="!canSave()"
		[saveOrCloseButtonText]="strings.UICONTROL_TEXT_SAVE | uppercase"
	>
		<button
			leftButton
			mat-button
			color="warn"
			automationId="delete"
			*ngIf="item"
			(click)="handleItemEvent({ type: 'Delete', event: $event })"
		>
			{{ strings.UICONTROL_TEXT_DELETE | uppercase }}
		</button>
		<div middleButton class="middle-buttons">
			<button
				mat-button
				color="primary"
				(click)="handleItemEvent({ type: 'RESEND', event: $event })"
				*ngIf="isInvitedUser"
				automationId="resend"
			>
				{{ strings.PROJECT_MEMBER_INVITED_SECTION_RESEND_BUTTON | uppercase }}
			</button>
			<button
				mat-button
				color="primary"
				automationId="cancel"
				(click)="handleItemEvent({ type: 'Cancel', event: $event })"
			>
				{{ strings.UICONTROL_TEXT_CANCEL | uppercase }}
			</button>
		</div>
	</button-footer>
</div>
